import jwtDecode from "jwt-decode";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ErrorHandler from "../../../../common/ErrorHandler";
import {
  currencyToNumber,
  indianCurrencyFormater,
} from "../../../../helpers/functions/currencyFormater";
import useLOSApplicationId from "../hooks/useLOSApplicationId";
import ViewButton from "../../../../common/batches/ViewButton";
import DownloadButton from "../../../../common/batches/DownloadButton";

const OpenApplicationIDModal = (props) => {
  const { onHide, modal, setModal, data } = props;
  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);

  const {
    formData,
    setFormData,
    buttonLoader,
    handleSubmitLOSApplicationId,
    handleChange,
    handleUpload,
    handleSendEmail,
  } = useLOSApplicationId({
    id: data?.taOnboardingCaseId,
    losApplicationId: data?.losApplicationId,
    losRequestDate: data?.losRequestDate,
    estCreditLimit: data?.estCreditLimit,
    personName: data?.personName,
    userState: data?.userState,
    crif_report: data?.crif_report,
  });

  try {
    return (
      <Modal
        {...props}
        size="md"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <div>
            <h5>LOS Application Details</h5>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-2">
            <div className="col">
              <label htmlFor="los_application_id">Application Id</label>

              <input
                type="text"
                className="form-control"
                name="los_application_id"
                value={formData?.los_application_id}
                placeholder="Application Id"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col">
              <label htmlFor="estCreditLimit">TA Proposed Limit</label>
              <input
                type="text"
                className="form-control"
                name="estCreditLimit"
                value={indianCurrencyFormater(formData.estCreditLimit, 0)}
                placeholder="TA Proposed Limit"
                onChange={(e) => {
                  const value = currencyToNumber(e.target.value);
                  setFormData((prev) => ({
                    ...prev,
                    ["estCreditLimit"]: value,
                  }));
                }}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col">
              <label htmlFor="losRequestDate"> LOS Request Date</label>
              <input
                type="date"
                className="form-control"
                name="losRequestDate"
                value={formData?.losRequestDate}
                placeholder=" Date"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="d-flex flex-wrap justify-content-between ">
              <div className="col-9">
                <label
                  htmlFor={"crif_report"}
                  className="btn btn-outline-primary btn-sm mb-0 p-2"
                >
                  Upload CRIF Report
                  <input
                    type="file"
                    id={"crif_report"}
                    name={"crif_report"}
                    style={{ display: "none" }}
                    onChange={(e) => handleUpload(e, "crif_report")}
                  />
                </label>
              </div>
              <div className="text-end fw-9">
                <button className="btn btn-success" onClick={handleSendEmail}>
                  <i class="bi bi-envelope-arrow-up-fill"></i>
                </button>
              </div>
              {/* <div className="col-12"> */}
              {formData?.crif_report_link !== "" && (
                <>
                  {/* <ViewButton file={formData?.crif_report_link} />
                    <DownloadButton file={formData?.crif_report_link} /> */}

                  <div
                    className="shadow-sm px-2 mb-2 border mt-2 rounded col-12"
                    style={{ backgroundColor: "rgb(239,246,255)" }}
                  >
                    <div className="d-flex flex-wrap justify-content-between">
                      <div className=" d-flex flex-wrap justify-content-between col-12 mt-2">
                        <strong
                          className="col-md-start mt-2"
                          style={{ color: "rgb(58,101,255)", fontSize: "12px" }}
                        >
                          <i class="bi bi-file-earmark me-2"></i>
                          Uploaded CRIF Report
                        </strong>
                        <span className="text-md-end mb-2">
                          {/* <strong
                                    className="col-md-start"
                                    style={{ color: "rgb(58,101,255)" }}
                                  >
                                    {limitSettingData["dpn_doc"]
                                      .documentName === "dpn_doc" &&
                                      "DPN Document "}
                                    :
                                  </strong> */}{" "}
                          <ViewButton file={formData?.crif_report_link} />|{" "}
                          <DownloadButton file={formData?.crif_report_link} />
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {/* </div> */}
            </div>
          </div>
          <hr className="soften mt-4 mb-2" />
          <div className="row mb-2">
            <div className="col">
              <label htmlFor="ta_credit_limit">TA Credit Limit</label>
              <input
                type="text"
                className="form-control"
                name="ta_credit_limit"
                value={indianCurrencyFormater(formData.ta_credit_limit, 0)}
                placeholder="TA Credit Limit"
                onChange={(e) => {
                  const value = currencyToNumber(e.target.value);
                  setFormData((prev) => ({
                    ...prev,
                    ["ta_credit_limit"]: value,
                  }));
                }}
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col">
              <label htmlFor="ta_agreement_Data">TA Agreement Date</label>
              <input
                type="date"
                className="form-control"
                name="ta_agreement_Data"
                value={formData?.ta_agreement_Data}
                placeholder="TA Agreement Date"
                onChange={handleChange}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
          <div className="d-flex justify-content-end">
            {buttonLoader ? (
              <button
                className="btn btn-primary"
                type="button"
                disabled
                id="loadingBtnTp"
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            ) : (
              <Button onClick={handleSubmitLOSApplicationId}>Submit</Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    );
  } catch (error) {
    return <ErrorHandler error={error} />;
  }
};

export default OpenApplicationIDModal;
